import { render, staticRenderFns } from "./blockPanel.vue?vue&type=template&id=3444dd84&scoped=true"
import script from "./blockPanel.vue?vue&type=script&lang=js"
export * from "./blockPanel.vue?vue&type=script&lang=js"
import style0 from "./blockPanel.vue?vue&type=style&index=0&id=3444dd84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3444dd84",
  null
  
)

export default component.exports